'use client';

import { useEffect, useState, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';
import IconRentBus from '@svg/icon-tourbus.svg';
import LinkForZzimcarAndroid from '../common/link-for-zzimcar-android';

export default function BackgroundRentBus() {
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null);
  const [position, setPosition] = useState(200);
  const [isMovingRight, setIsMovingRight] = useState(true);
  const [speed, setSpeed] = useState(1);
  const isHovered = useRef(false);
  const [showBubble, setShowBubble] = useState(false);
  const [innerWidth, setInnerWidth] = useState(0);

  useEffect(() => {
    setPortalElement(document.getElementById('background-portal'));

    const windowResizeHandler = () => {
      setInnerWidth(window.innerWidth);
    };
    window.addEventListener('resize', windowResizeHandler);
    setInnerWidth(window.innerWidth);
    return () => window.removeEventListener('resize', windowResizeHandler);
  }, []);

  useEffect(() => {
    const maxWidth = window.innerWidth;
    let animationFrameId: number;

    const animate = () => {
      if (!isHovered.current) {
        setPosition((prev) => {
          if (isMovingRight) {
            if (prev >= maxWidth) {
              setIsMovingRight(false);
              return maxWidth;
            }
            return prev + speed;
          } else {
            if (prev <= -120) {
              setIsMovingRight(true);
              return -120;
            }
            return prev - speed;
          }
        });
      }
      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrameId);
  }, [isMovingRight, speed]);

  if (!portalElement || innerWidth < 1024) return null;

  return createPortal(
    <div className='relative opacity-90'>
      <LinkForZzimcarAndroid
        href={process.env.NEXT_PUBLIC_ZZIMCAR_RENTBUS_URL ?? ''}
        target='_blank'
        className='fixed bottom-15pxr w-120pxr h-104pxr transition-transform cursor-pointer'
        style={{
          left: `${position}px`,
          transform: `scaleX(${isMovingRight ? 1 : -1}) scale(${isHovered.current ? 1.1 : 1})`,
          transition: 'transform 0.3s ease',
        }}
        onMouseEnter={() => {
          isHovered.current = true;
          setShowBubble(true);
        }}
        onMouseLeave={() => {
          isHovered.current = false;
          setShowBubble(false);
        }}
      >
        {showBubble && (
          <div
            className='absolute -top-20pxr left-1/2 -translate-x-1/2 bg-white px-12pxr py-8pxr rounded-lg shadow-md'
            style={{
              transform: `scaleX(${isMovingRight ? 1 : -1}) translateX(${isMovingRight ? '-50%' : '50%'})`,
            }}
          >
            <div className='relative'>
              <p className='whitespace-nowrap text-14pxr text-gray-800'>🚌 투어버스로 편하게 여행하세요!</p>
              <div className='absolute -bottom-12pxr left-1/2 -translate-x-1/2 border-8 border-transparent border-t-white' />
            </div>
          </div>
        )}
        <IconRentBus />
      </LinkForZzimcarAndroid>
    </div>,
    portalElement,
  );
}
